import * as z from 'zod';

export const PublicApiConfigSchema = z.object({
  baseUrl: z.string().nonempty(),
});

export type PublicApiConfig = z.infer<typeof PublicApiConfigSchema>;

export const publicApiConfig = Object.freeze(
  PublicApiConfigSchema.parse({
    baseUrl: import.meta.env.APP_CLIENT_WEB_PUBLIC_API_BASE_URL,
  }),
);
